import React from "react";
import EmailIcon from "../assets/icon_email.svg";
import PhoneIcon from "../assets/icon_phone.svg";
import LocationIcon from "../assets/icon_address.svg";
import Reveal from "../components/Reveal";

const details = [
  {
    icon: EmailIcon,
    title: "Email",
    value: "contact@deepcvision.co.uk",
    href: "mailto:contact@deepcvision.co.uk",
  },
  {
    icon: PhoneIcon,
    title: "Phone",
    value: "+44 (0) 7549 348 927",
    href: "tel:+447549348927",
  },
  {
    icon: LocationIcon,
    title: "Address",
    value: "54 Avondale Road, Bromley, BR1 4EP, United Kingdom",
  },
];

const ContactUs = () => {
  return (
    <div className="bg-ink pt-28 lg:pt-32">
      {/* Hero */}
      <section className="relative overflow-hidden px-6 pt-16 pb-20 text-center">
        <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_60%_60%_at_50%_40%,rgba(91,62,255,0.16)_0%,transparent_70%)]" />
        <div className="pointer-events-none absolute inset-0 hero-grid" />

        <div className="relative z-10 max-w-4xl mx-auto">
          <p className="eyebrow mb-6 fade-up" style={{ animationDelay: "0.2s" }}>
            Contact
          </p>
          <h1
            className="font-display text-[clamp(56px,10vw,120px)] leading-[0.92] tracking-wide text-paper fade-up"
            style={{ animationDelay: "0.35s" }}
          >
            Let's <span className="text-brand-cyan">talk</span>
          </h1>
          <p
            className="mt-7 mx-auto max-w-xl text-muted text-[17px] leading-relaxed fade-up"
            style={{ animationDelay: "0.55s" }}
          >
            Tell us what you're building — we usually reply within a day.
          </p>
          <div
            className="mt-10 fade-up"
            style={{ animationDelay: "0.75s" }}
          >
            <a href="mailto:contact@deepcvision.co.uk" className="btn-primary">
              Email us
            </a>
          </div>
        </div>
      </section>

      {/* Details */}
      <section className="border-t border-ink-line bg-ink-soft px-6 sm:px-12 lg:px-20 py-24">
        <div className="max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-6">
          {details.map(({ icon, title, value, href }, i) => (
            <Reveal key={title} delay={i * 110}>
              <div className="surface-card h-full p-9 flex flex-col items-start">
                <img
                  src={icon}
                  alt=""
                  aria-hidden="true"
                  className="w-12 h-12 mb-7 object-contain"
                />
                <h3 className="eyebrow mb-3">{title}</h3>
                {href ? (
                  <a
                    href={href}
                    className="text-paper text-[15px] hover:text-brand-cyan transition-colors break-words"
                  >
                    {value}
                  </a>
                ) : (
                  <p className="text-paper text-[15px] leading-relaxed">
                    {value}
                  </p>
                )}
              </div>
            </Reveal>
          ))}
        </div>
      </section>
    </div>
  );
};

export default ContactUs;
